/**
 * Encodes a Uint8Array to a Base64 string.
 * Uses the browser's built-in btoa function for encoding.
 *
 * @param data - Bytes to encode
 * @returns Base64 encoded string
 *
 * @example
 * ```ts
 * import { Base64Encode } from "@pdfking/tfunc"
 *
 * const bytes = new TextEncoder().encode("Hello World")
 * const encoded = Base64Encode(bytes) // "SGVsbG8gV29ybGQ="
 * ```
 */
// fromCharCode takes its bytes as arguments: spread in pieces this size, or a
// large array overflows the call stack
const PIECE = 32768

export const Base64Encode = (data: Uint8Array): string => {
  let binary = ""
  for (let at = 0; at < data.length; at += PIECE) {
    binary += String.fromCharCode(...data.subarray(at, at + PIECE))
  }
  return btoa(binary)
}
